import { CONTAINER, TYPES } from '../../../config';

import { Dictionary, GetterClass, MessagesState } from '../../../models';

import { MESSAGES_CONSTS } from '../../../store/messages/messages.consts';

export class MessagesGetter implements GetterClass {

  public static execute(state: MessagesState, getters: any): Dictionary {
    const messages = CONTAINER.get<Dictionary<Dictionary>>(TYPES.Messages);
    return messages[getters[MESSAGES_CONSTS.getters.locale]];
  }

}
